import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  CircularProgress,
  Alert,
  TextField,
  Link,
} from '@mui/material';
import config from "../../twh/config";
import { getFirstErrorMessage } from "../../twh/functions";

const GoogleAnalyticsProperty = () => {
  const [propertyId, setPropertyId] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!propertyId) {
      setError('Property ID is required');
      return;
    }

    setSubmitting(true);
    setError(null);
    setSuccess(false);

    try {
      const formData = new FormData();
      formData.append('issetGooglePropertyID', 'true');
      formData.append('google_analytics_property_id', propertyId);

      const response = await fetch(
        `${config.reactApi_baseUrl}/react-api/integrations/google-analytics-property-update.php`,
        {
          method: 'POST',
          body: formData,
          credentials: 'include',
        }
      );

      const data = await response.json();

      if (data.status === true) {
        setSuccess(true);

        setTimeout(() => {
          window.location.href = "/website-data";
        }, 1200);
      } else {
        const errMsg =
          getFirstErrorMessage(data) ||
          data.errorMsg ||
          'Failed to save changes';

        setError(errMsg);
      }
    } catch (err) {
      setError('Submit error: ' + err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box>
      {/* Alerts */}
      {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}
      {success && (
        <Alert severity="success" sx={{ mb: 3 }}>
          Changes saved successfully! Redirecting...
        </Alert>
      )}

      <form onSubmit={handleSubmit}>
        <Card elevation={3} sx={{ overflow: 'visible', px: 5 }}>
          
          {/* Logo */}
          <Box sx={{ textAlign: 'center', pt: 5, pb: 3 }}>
            <img
              src={`${config.reactApi_baseUrl}/media/images/google-analytics.png`}
              alt="Google Analytics"
              style={{ width: 150, height: 150, objectFit: 'contain' }}
            />
          </Box>

          <CardContent sx={{ px: 4, pb: 4 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Google Analytics
            </Typography>

            {/* Property ID Field */}
            <Box sx={{ mb: 3 }}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  mb: 1,
                }}
              >
                <Typography variant="body1">
                  Property ID
                </Typography>

                <Link
                  href="https://analytics.google.com/"
                  target="_blank"
                  rel="noopener"
                  underline="hover"
                  sx={{ fontSize: 13 }}
                >
                  Property ID Find
                </Link>
              </Box>

              <TextField
                fullWidth
                placeholder="Enter Property ID"
                value={propertyId}
                onChange={(e) => setPropertyId(e.target.value)}
              />
            </Box>

            {/* Submit Button */}
            <Box sx={{ textAlign: 'right', mt: 4 }}>
              <Button
                type="submit"
                variant="contained"
                disabled={submitting || !propertyId}
                sx={{
                  bgcolor: '#e91e63',
                  '&:hover': { bgcolor: '#c2185b' },
                  px: 4,
                  py: 1.2,
                  textTransform: 'none',
                  fontWeight: 'bold',
                }}
              >
                {submitting ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  'Save Changes'
                )}
              </Button>
            </Box>
          </CardContent>
        </Card>
      </form>
    </Box>
  );
};

export default GoogleAnalyticsProperty;